<style scoped>
.title {
  padding: 10px 15px;
  font-size: 14px;
}
</style>

<template>
  <div class="table">
    <div class="title">
      <span>企业名称：{{name}}</span>
      <br>
      <span>企业地址：{{address}}</span>
    </div>
    <el-table :data="tableData" border max-height="430">
      <el-table-column type="index" width="50" label="序号" align="center"></el-table-column>
      <el-table-column prop="vehicleNumber" label="车牌号" align="center"></el-table-column>
      <el-table-column prop="isCard" label="是否已办联名卡" align="center"></el-table-column>
      <el-table-column prop="cardCount" label="办卡数量" align="center">
        <template slot-scope="scope">
          {{format(scope.row.cardCount)}}
        </template>
      </el-table-column>
      <el-table-column prop="firstTime" label="首次办卡时间" align="center"></el-table-column>
      <el-table-column prop="lastOpetime" label="最后一次消费时间" align="center"></el-table-column>
      <el-table-column prop="runProvince" label="常运营省份" align="center"></el-table-column>
      <el-table-column label="非石化油站停靠次数" align="center">
        <template slot-scope="scope">{{format(scope.row.petroleumStopCount*1 + scope.row.otherStopCount*1)}}</template>
      </el-table-column>
      <el-table-column prop="petroleumStopCount" align="center" label="中国石油油站停靠次数">
        <template slot-scope="scope">
          {{format(scope.row.petroleumStopCount)}}
        </template>
      </el-table-column>
      <el-table-column prop="otherStopCount" align="center" label="其他油站停靠次数">
        <template slot-scope="scope">
          {{format(scope.row.otherStopCount)}}
        </template>
      </el-table-column>
      <el-table-column prop="mileage" align="center" label="运营公里数(公里)">
        <template slot-scope="scope">
          {{format(scope.row.mileage)}}
        </template>
      </el-table-column>
    </el-table>
    <slot/>
  </div>
</template>
<script>
/**
 * @file:  View 组件 table
 * @author: v_chengmengya
 * @date: 2019-05-15
 * @description: UI组件
 */
export default {
  props: {
    tableData: {
      default: () => {
        return []
      },
      type: Array
    },
    name: {
      default: '',
      type: String
    },
    address: {
      default: '',
      type: String
    }
  },
  methods:{
    format(num) {
      var reg = /\d{1,3}(?=(\d{3})+$)/g
      return (num + '').replace(reg, '$&,')
    },
  }
}
</script>
